import { useEffect, useState } from 'react'
import { backendGetRequest } from '../../../../helpers/callBackend'
import FormattedTabs from '../../../../components/generic/formattedTabs'
import theme from '../../../../helpers/theme'
import Box from '@mui/material/Box'
import InternalPayments from './InternalPayments'
import ExternalPayments from './ExternalPayments'
import checkFlag from '../../../../helpers/featureFlags'
import ComingSoonTab from './ComingSoonTab'

const SendFundsPage = () => {
  const [bankAccounts, setBankAccounts] = useState([])
  const [counterparties, setCounterparties] = useState([])
  const [bankAccountCount, setBankAccountCount] = useState(0)
  const [counterpartyCount, setCounterpartyCount] = useState(0)
  const [loadingBankAccounts, setLoadingBankAccounts] = useState(false)
  const [loadingCounterparties, setLoadingCounterparties] = useState(false)
  const [last4ToInternalAccountMap, setLast4ToInternalAccountMap] = useState({})
  const [createdPaymentRequests, setCreatedPaymentRequests] = useState([])
  const [failedPaymentRequests, setFailedPaymentRequests] = useState([])

  const bankAccountGetParams = {
    quick_get: true,
    payment_verified: true,
  }
  const counterpartyGetParams = {
    quick: true,
    fundingSources: true,
    includeLast4: true,
  }

  const getBankAccountsPage = async (pageNum) => {
    try {
      const bankAccountResp = await backendGetRequest('/api/bank-account', {
        params: {
          ...bankAccountGetParams,
          page_index: pageNum,
        },
      })
      setBankAccounts((prevState) => [...prevState, ...bankAccountResp.data?.data])
    } catch (error) {
      return
    }
  }

  const getBankAccounts = async () => {
    setLoadingBankAccounts(true)
    setBankAccounts([])
    let totalPages = 0
    try {
      const pageInfo = await backendGetRequest('/api/bank-account', {
        params: {
          ...bankAccountGetParams,
          page_index: 0,
        },
      })
      totalPages = pageInfo.data?.total_pages
      setBankAccountCount(pageInfo.data?.total_records)
    } catch (error) {
      console.error(error)
      return
    }

    for (let pageNum = 1; pageNum < totalPages + 1; pageNum++) {
      getBankAccountsPage(pageNum)
    }
  }

  const getCounterpartiesPage = async (pageNum) => {
    setLoadingCounterparties(true)
    try {
      const counterpartyResp = await backendGetRequest('/api/payments/counterparty', {
        params: {
          ...counterpartyGetParams,
          pageIndex: pageNum,
        },
      })
      setCounterparties((prevState) => [...prevState, ...counterpartyResp.data?.data])
    } catch (error) {
      return
    }
  }

  const getCounterparties = async () => {
    setCounterparties([])
    let totalPages = 0
    try {
      const pageInfo = await backendGetRequest('/api/payments/counterparty', {
        params: {
          ...counterpartyGetParams,
          pageIndex: 0,
        },
      })
      totalPages = pageInfo.data?.total_pages
      setCounterpartyCount(pageInfo.data?.total_records)
    } catch (error) {
      console.error(error)
      return
    }

    for (let pageNum = 1; pageNum < totalPages + 1; pageNum++) {
      getCounterpartiesPage(pageNum)
    }
  }

  useEffect(() => {
    setLast4ToInternalAccountMap((prevState) => {
      const newMapping = {}
      bankAccounts.forEach((account) => {
        const last4 = account.account.account_number_last_4
        if (last4) {
          newMapping[last4] = account
        }
      })
      return newMapping
    })
  }, [bankAccounts])

  useEffect(() => {
    if (counterparties.length >= counterpartyCount) {
      setLoadingBankAccounts(false)
    }
  }, [counterparties])

  useEffect(() => {
    if (bankAccounts.length >= bankAccountCount) {
      setLoadingCounterparties(false)
    }
  }, [bankAccounts])

  useEffect(() => {
    document.title = "Arpari | Payments"
    if (!checkFlag('paymentsV2')) {
      return
    }
    getBankAccounts()
    getCounterparties()
  }, [])

  const tabPanes = !checkFlag('paymentsV2')
    ? [
      {
        title: 'Internal Payments',
        key: 0,
        body: <ComingSoonTab title='Internal Payments' />,
      },
      {
        title: 'External Payments',
        key: 1,
        body: <ComingSoonTab title='External Payments' />,
      },
    ]
    : [
      {
        title: 'Internal Payments',
        key: 0,
        body: (
          <InternalPayments
            internalAccounts={bankAccounts}
            loadingInternalAccounts={loadingBankAccounts}
            last4ToInternalAccountMap={last4ToInternalAccountMap}
            setCreatedPaymentRequests={setCreatedPaymentRequests}
            setFailedPaymentRequests={setFailedPaymentRequests}
          />
        ),
      },
      {
        title: 'External Payments',
        key: 1,
        body: (
          <ExternalPayments
            recipients={counterparties}
            loadingRecipients={loadingCounterparties}
            loadingInternalAccounts={loadingBankAccounts}
            last4ToInternalAccountMap={last4ToInternalAccountMap}
            internalAccounts={bankAccounts}
            setCreatedPaymentRequests={setCreatedPaymentRequests}
            setFailedPaymentRequests={setFailedPaymentRequests}
          />
        ),
      },
    ]

  return (
    <Box
      sx={{
        overflow: 'auto',
        maxHeight: '99%',
      }}
    >
      <Box sx={{ margin: theme.dashboard.margins }}>
        <FormattedTabs defaultActiveKey={0} tabPanes={tabPanes} />
      </Box>
    </Box>
  )
}

export default SendFundsPage
